import { osName } from 'react-device-detect';

import { useClientHasRendered } from '../hooks';

export const useGetOsName = (): string => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered ? osName : '';
};
